import { CURRICULUMS, StudentServicePath, TOPICS } from "utils/constants";
import permissions from "app/permissions";
import EditTopics from "./Edit";

export const resources = {
  name: StudentServicePath + TOPICS + "/" + CURRICULUMS + "/:id/edit",
  title: "Редакция тема",
  custom: <EditTopics />,
  permission: permissions.canManageCurriculumDisciplinesTopics,
};
